import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://hviaowpyijlkrwezvubu.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh2aWFvd3B5aWpsa3J3ZXp2dWJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA0NTQ3MTksImV4cCI6MjA5NjAzMDcxOX0.-_BL6Zs6j-fDBvdGwmkzZOPkdcX5BqrSq0zzGWgNW1g'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

export interface GuestbookEntryRow {
  id: string
  name: string
  message: string
  created_at: string
}

export interface SubscriberRow {
  id: string
  email: string
  created_at: string
}
